import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { ClickPreventDefaultDirective } from '../directives/click/click-prevent-default.directive';
import { TranslatePipe } from '@ngx-translate/core';
import ShortUniqueId from 'short-unique-id';

@Component({
  selector: 'mwe-expander-basic',
  templateUrl: 'expander-basic.component.html',
  imports: [NgbCollapse, ClickPreventDefaultDirective, TranslatePipe],
})
export class ExpanderBasicComponent implements OnInit {
  @ViewChild('collapsible') collapsibleRef: ElementRef;
  @Input() textKey: string;
  @Input() textCss: string;
  @Input() showMoreKey = 'global.expander.showMore';
  @Input() showLessKey = 'global.expander.showLess';
  @Input() hideTeaser: boolean;
  isCollapsed = true;
  uuid: string;

  constructor() {}

  ngOnInit(): void {
    this.uuid = new ShortUniqueId({ dictionary: 'alpha' }).rnd(8);
  }
}
